import type { AxiosResponse } from 'axios';
import type { Review } from '@app-types/models/review';
import api from './api';

interface ReviewsResponse {
  reviews: Review[];
  [key: string]: unknown;
}

interface ReviewReplyResponse {
  review: Review;
  [key: string]: unknown;
}

interface AddReviewReplyParams {
  reviewId: string;
  reply: string;
  staffId: string;
}

interface UpdateReviewReplyParams {
  reviewId: string;
  replyId: string;
  reply: string;
  staffId: string;
}

interface DeleteReviewReplyParams {
  reviewId: string;
  replyId: string;
  staffId: string;
}

export const getReviews = async (stylistId: string): Promise<ReviewsResponse> => {
  try {
    const response: AxiosResponse<ReviewsResponse> = await api.get('/business/reviews', {
      params: { stylistId }
    });
    return response.data;
  } catch (error: unknown) {
    const axiosError = error as { response?: { data?: { message?: string } } };
    throw new Error(axiosError.response?.data?.message || 'Failed to fetch reviews');
  }
};

export const addReviewReply = async ({ reviewId, reply, staffId }: AddReviewReplyParams): Promise<ReviewReplyResponse> => {
  try {
    const response: AxiosResponse<ReviewReplyResponse> = await api.post(
      `business/reviews/reply`,
      {
        reply,
        reviewId,
        staffId
      }
    );
    return response.data;
  } catch (error: unknown) {
    const axiosError = error as { response?: { data?: { message?: string } } };
    throw new Error(axiosError.response?.data?.message || 'Failed to add reply');
  }
};

export const updateReviewReply = async ({ reviewId, replyId, reply, staffId }: UpdateReviewReplyParams): Promise<ReviewReplyResponse> => {
  try {
    const response: AxiosResponse<ReviewReplyResponse> = await api.put(
      `business/reviews/reply`,
      {
        reply,
        reviewId,
        replyId,
        staffId
      }
    );
    return response.data;
  } catch (error: unknown) {
    const axiosError = error as { response?: { data?: { message?: string } } };
    throw new Error(axiosError.response?.data?.message || 'Failed to update reply');
  }
};

export const deleteReviewReply = async ({ reviewId, replyId, staffId }: DeleteReviewReplyParams): Promise<ReviewReplyResponse> => {
  try {
    const response: AxiosResponse<ReviewReplyResponse> = await api.delete(
      `business/reviews/reply`,
      {
        data: {
          reviewId,
          replyId,
          staffId
        }
      }
    );
    return response.data;
  } catch (error: unknown) {
    const axiosError = error as { response?: { data?: { message?: string } } };
    throw new Error(axiosError.response?.data?.message || 'Failed to delete reply');
  }
};
